export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00844.dbb3e1dc.png";